export default "__VITE_ASSET__29c9a29e__"